export const CONSTANT = {

  BASE_URL: process.env.VUE_APP_ROOT_API,
  MASTERPASS_URL: process.env.VUE_APP_MASTERPASS_MTT_HOST,
  ADVANCED_TAB: process.env.VUE_APP_ENABLE_ADVANCE,

  CONFIG: {
    TITLE: {
      CONFIGURATION: 'configuration',
      CHECKOUT: 'checkout',
      FEDERATEDID: 'federatedid',
      TOKENIZATION: 'tokenization',
      STOREFRONT: 'storefront',
      CALLBACK: 'callback',
      ADVANCED: 'advanced',
      AUTH: 'auth'
    },
    LOCALE: [
      { value: '-- English --', separator: true },
      { value: 'en_AE' },
      { value: 'en_AU' },
      { value: 'en_CA' },
      { value: 'en_GB' },
      { value: 'en_HK' },
      { value: 'en_IE' },
      { value: 'en_KW' },
      { value: 'en_NZ' },
      { value: 'en_QA' },
      { value: 'en_SA' },
      { value: 'en_SG' },
      { value: 'en_TH' },
      { value: 'en_US' },
      { value: '-- Spanish --', separator: true },
      { value: 'es_AR' },
      { value: 'es_CL' },
      { value: 'es_CO' },
      { value: 'es_MX' },
      { value: 'es_PE' },
      { value: '-- French --', separator: true },
      { value: 'fr_CA' },
      { value: '-- Ukraine --', separator: true },
      { value: 'uk_UA' },
      { value: '-- Other --', separator: true },
      { value: 'Other' }
    ],

    OTHER_LOCALE: 'Other',

    CURRENCIES: [{
      code: 'AED',
      symbol: 'د.إ'
    },
    {
      code: 'AUD',
      symbol: '&#36;'
    },
    {
      code: 'BRL',
      symbol: 'R&#36;'
    },
    {
      code: 'EUR',
      symbol: '&#8364;'
    },
    {
      code: 'HKD',
      symbol: 'HK&#36;'
    },
    {
      code: 'INR',
      symbol: '&#8377;'
    },
    {
      code: 'NZD',
      symbol: '&#36;'
    },
    {
      code: 'SGD',
      symbol: 'S&#36;'
    },
    {
      code: 'TRY',
      symbol: '&#8378;'
    },
    {
      code: 'USD',
      symbol: '&#36;'
    },
    {
      code: 'ZAR',
      symbol: 'R'
    },
    {
      code: 'UAH',
      symbol: '&#x20B4'
    }
    ],
    BILLING_ADDRESS: {
      'Full billing address': 'FULL',
      'Billing zip code': 'POSTAL_COUNTRY',
      'Suppress billing address': 'NONE'
    },
    SHIPPING_ADDRESS: {
      'Full shipping address': 'FULL',
      'Shipping zip code': 'POSTAL_COUNTRY',
      'Suppress shipping address': 'NONE'
    },
    DCF_PREFERENCE: {
      'Inside Checkout': 'WITHIN_CHECKOUT',
      'Outside Checkout': 'PAYMENT_SETTINGS',
      'None': 'NONE'
    },

    MASTERCARD_DCF_PREFERENCE: {
      'WITHIN_CHECKOUT': 'WITHIN_CHECKOUT',
      'PAYMENT_SETTINGS': 'PAYMENT_SETTINGS',
      'NONE': 'NONE'
    },

    AMEX_DCF_PREFERENCE: {
      'withinCheckout': 'withinCheckout',
      'paymentSetting': 'paymentSetting'
    },

    DISCOVER_DCF_PREFERENCE: {
      'PAYMENT_SETTINGS': 'PAYMENT_SETTINGS',
      'WITHIN_CHECKOUT': 'WITHIN_CHECKOUT'
    },

    VISA_DCF_PREFERENCE: {
      'withincheckout': 'withincheckout',
      'paymentsetting': 'paymentsetting'
    },

    CONFIRM_PAYMENT_OPTIONS: {
      'True': true,
      'False': false
    },

    CHECKOUT_TYPE_OPTIONS: {
      'None': 'NONE',
      'Dual Party Checkout - Dual Model': 'DUAL_MODEL',
      'Dual Party Checkout - Pull Model': 'PULL_MODEL'
    },

    THREE_DS_PREFERENCE_OPTIONS: {
      'None': 'NONE',
      'Self': 'SELF',
      'Null': null
    },

    CRYPTO_OPTIONS: {
      'master': {
        'UCAF': 'UCAF (Mastercard MDES)',
        'ICC': 'ICC (Mastercard MDES)'
      },
      'visa': {
        'TAVV': 'TAVV (Visa VTS)'
      },
      'dcvc2': {
        'DCVC2': 'DCVC2'
      }
    },
    TOKENIZATION: {
      'cryptoFormatType': {
        'UCAF': 'UCAF',
        'ICC': 'ICC',
        'TAVV': 'TAVV',
        'DCVC2': 'DCVC2'
      }
    },
    ENVIRONMENT: {
      SANDBOX: 'Sandbox',
      STAGE: 'Stage',
      PRODUCTION: 'Production',
      ITF: 'ITF'
    },
    PAYLOAD_RETRIEVAL_TYPES: {
      SUMMARY: 'SUMMARY',
      FULL: 'FULL',
      PAYMENT: 'PAYMENT',
      NON_PAYMENT: 'NON_PAYMENT',
      NONE: 'NONE'
    },
    CONSUMER_PROFILE_PREFERENCES: {
      'Consumer Name': 'consumerNameRequested',
      'Consumer Email': 'consumerEmailAddressRequested',
      'Consumer Phone Number': 'consumerPhoneNumberRequested'
    },
    JWT_TESTING_ENABLE: {
      'Off': 'off',
      'On': 'on'
    },

    SANDBOX_JS_URL: {
      MASTERCARD: 'https://sandbox.src.mastercard.com/sdk/srcsdk.mastercard.js',
      VISA: 'https://sandbox-assets.secure.checkout.visa.com/checkout-widget/resources/js/src-i-adapter/visaSdk.js',
      AMEX: 'https://qwww.aexp-static.com/akamai/remotecommerce/scripts/amexSDK-1.0.0.js',
      DISCOVER: 'https://webapp.sandbox.src.discover.com/websdk/dgnSS-SDK-0.0.1.js'
    },

    COF_TESTING_ENABLE: {
      'Off': false,
      'On': true
    },

    PRODUCT_NAVIGATION_LIST: [
      'Jackets',
      'T-Shirts',
      'Merchandise'
    ],

    MOBILE_SUPPORT_OPTIONS: {
      'True': true,
      'False': false
    },

    AUTHENTICATION_METHOD_TYPES: {
      '3DS': '3DS',
      'null': null
    },

    SUPPRESS_CHALLENGE: {
      'True': true,
      'False': false,
      'null': null
    },

    PAYLOAD_REQUESTED: {
      'AUTHENTICATED': 'AUTHENTICATED',
      'NON_AUTHENTICATED': 'NON_AUTHENTICATED',
      'null': null
    },

    THIRDPARTY_FIDO: {
      'Use Generic MFA Flow': 'genericMFA',
      'Use 3rd Party FIDO MFA Flow': 'thirdPartyFIDO',
      'Use 3rd Party PKI Flow': 'thirdPartyPKI'
    },

    PKI_FORMAT: {
      'None': 'none',
      'Packed': 'packed',
      'Android': 'android-key',
      'ios': 'apple-appattest'
    },

    B2B_LOOKUP_REASON: {
      'ENROL_FINANCIAL_INSTRUMENT': 'ENROL_FINANCIAL_INSTRUMENT',
      'CONSUMER_IDENTITY_VALIDATION': 'CONSUMER_IDENTITY_VALIDATION',
      'AUTHENTICATOR_REGISTRATION': 'AUTHENTICATOR_REGISTRATION',
      'TRANSACTION_AUTHENTICATION': 'TRANSACTION_AUTHENTICATION'
    },

    FORCE_CHALLENGE_OPTIONS: {
      'True': true,
      'False': false
    }

  },

  CART_DETAILS: {
    TAX: 0.05,
    SHIPPING: 5,
    ZERO: 0,
    DIGITAL: false
  },

  ACCOUNT: {
    USERNAME: 'John Smith'
  },

  CARD_ENROLLMENT: {
    label: {
      addNewCard: 'Add new card',
      cardEndingIn: 'Card ending in',
      cardExpiry: 'Expiry',
      cardNumber: 'Card Number',
      newUser: 'NEW',
      register: 'register',
      login: 'login',
      payTo: 'Pay To',
      payWith: 'Select Card for Payment',
      returningUser: 'RETURNING',
      securePayId: 'Secure Pay ID'
    }
  },

  ERROR_MSG: {
    invalidSecureCode: 'Invalid secure code',
    invalidCardNumber: 'Invalid payment card number. Please try again',
    sdkNotLoaded: 'Could not load SDK.',
    apiFailureMsg: 'Refer response.'
  },

  SRC: {
    CART: 'CART',
    CONFIGURATION: 'CONFIGURATION',
    POPUP_CART: 'POPUP_CART',
    INLINE_CARD: 'INLINE_CARD'
  },

  TRACE: {
    METHOD: {
      BOOTSTRAP: 'bootstrap',
      INIT: 'init',
      ISRECOGNIZED: 'isRecognized',
      INIT_FRAME: 'initIframe',
      ENROLL_CARD: 'enrollCard',
      CHECKOUT: 'checkout',
      GET_SRC_PROFILE: 'getSrcProfile',
      ID_LOOKUP: 'identityLookup',
      COMPLETE_ID_VALIDATION: 'completeIdentityValidation',
      INITIATE_ID_VALIDATION: 'initiateIdentityValidation',
      ADD_CARD: 'addCard',
      UNBIND_APP_INSTANCE: 'unbindAppInstance',
      GET_FEDERETED_TOKEN: 'federatedToken',
      USER_ACCESS: 'userAccess',
      AUTHENTICATE_CONSUMER: 'authenticate',
      AUTHENTICATION_METHODS_LOOKUP: 'authenticationMethodsLookup'
    }
  },

  AGGREGATOR_METHOD: {
    BOOTSTRAP: 'Initialize',
    INIT: 'AggregatorInit',
    ISRECOGNIZED: 'AggregatorIsRecognized',
    GET_SRC_PROFILE: 'AggregatorGetSrcProfile',
    ID_LOOKUP: 'AggregatorIdentityLookup',
    COMPLETE_ID_VALIDATION: 'AggregatorCompleteIdentityValidation',
    INITIATE_ID_VALIDATION: 'AggregatorInitiateIdentityValidation',
    CHECKOUT: 'AggregatorCheckout',
    UNBIND_APP_INSTANCE: 'AggregatorUnbindAppInstance'
  },

  SRCSDK_MASTERCARD: 'MASTERCARD',
  SRCSDK_VISA: 'VISA',
  SRCSDK_AMEX: 'AMEX',
  SRCSDK_DISCOVER: 'DISCOVER',

  SRCSDK_MASTERCARD_NTW: 'MASTERCARD NETWORK',
  SRCSDK_VISA_NTW: 'VISA NETWORK',
  SRCSDK_AMEX_NTW: 'AMEX NETWORK',
  SRCSDK_DISCOVER_NTW: 'DISCOVER NETWORK',

  PAYLOAD_KEY: {
    MASTERCARD: 'decryptedPayload',
    VISA: 'visaEncPayloadResponse',
    AMEX: 'paymentPayloadResponse',
    DISCOVER: 'decryptedPayload'
  },

  DEFAULT_CARD_LOGO: {
    MASTERCARD: 'mastercard_logo.png',
    VISA: 'visa_logo.png',
    AMEX: 'amex_logo.png',
    DISCOVER: 'discover_logo.png'
  },

  APP_NAME: {
    ABBR: 'START',
    FULL: 'SRC Test Application and Reference Tool '
  },

  PAN_ENC: {
    ENCRYPTION_CONTENT_ALGO: 'A256GCM',
    ENC_ALGO: 'RSA-OAEP-256'
  },

  TOKENIZATION_OPTIONS: {
    MASTERCARD: {
      'UCAF - CARD APPLICATION CRYPTOGRAM SHORT FORM': 'CARD_APPLICATION_CRYPTOGRAM_SHORT_FORM',
      'DTD - DYNAMIC CARD SECURITY CODE': 'DYNAMIC_CARD_SECURITY_CODE',
      '3DS AAV - CARDHOLDER_AUTHENTICATION_CRYPTOGRAM': 'CARDHOLDER_AUTHENTICATION_CRYPTOGRAM',
      'NONE': 'NONE'
    },

    VISA: {
      'TAVV - Transaction Authentication Verification Value': 'TAVV',
      'DTVV - Dynamic Token Verification Value': 'DTVV',
      NONE: ''
    },

    AMEX: {
      'DTD - CARD SECURITY CODE': 'CARD_SECURITY_CODE'
    },

    DISCOVER: {
      'CARD APPLICATION CRYPTOGRAM LONG FORM': 'CARD_APPLICATION_CRYPTOGRAM_LONG_FORM',
      'CARD APPLICATION CRYPTOGRAM SHORT FORM': 'CARD_APPLICATION_CRYPTOGRAM_SHORT_FORM',
      'DYNAMIC CARD SECURITY CODE': 'DYNAMIC_CARD_SECURITY_CODE',
      'CARDHOLDER AUTHENTICATION CRYPTOGRAM': 'CARDHOLDER_AUTHENTICATION_CRYPTOGRAM',
      NONE: ''
    }
  },

  CALLBACK_ROUTE: '/configuration/callback',
  CODE_LENGTH: 6,

  INLINE_SCREEN: {
    LOGIN_SCREEN: 'LOGIN_SCREEN',
    REGISTER_SCREEN: 'REGISTER_SCREEN',
    OTP_SCREEN: 'OTP_SCREEN',
    PAYMENT_SCREEN: 'PAYMENT_SCREEN',
    ADD_CARD_SCREEN: 'ADD_CARD_SCREEN',
    OTP_METHOD_SCREEN: 'OTP_METHOD_SCREEN',
    GUEST_CHECKOUT_SCREEN: 'GUEST_CHECKOUT_SCREEN',
    'login': 'LOGIN_SCREEN',
    'register': 'LOGIN_SCREEN'
  },

  SCREEN_URI: {
    LOGIN_SCREEN: 'login',
    REGISTER_SCREEN: 'register',
    OTP_SCREEN: 'otp-authentication',
    PAYMENT_SCREEN: 'payment-method',
    ADD_CARD_SCREEN: 'addcard',
    OTP_METHOD_SCREEN: 'otp-methods',
    GUEST_CHECKOUT_SCREEN: 'guest-checkout',
    'login': 'login',
    'register': 'register'
  },

  GUEST_TXT: 'Checkout as a guest',
  RETRIES_EXCEEDED: 'RETRIES_EXCEEDED',
  SESSION_NOT_FOUND: 'SESSION_NOT_FOUND',
  TRANSACTION_TYPE: 'PURCHASE',
  NONE: 'NONE',
  APP_INSTANCE_KEY: 'appInstanceId',
  REGION: {
    GLOBAL: 'GLOBAL',
    IND: 'IND'
  },
  SCOF_CURRENCY: {
    GLOBAL: 'USD',
    IND: 'INR'
  }

}

export const SDK_ID_MASTERCARD = 'mastercard'
export const SDK_ID_VISA = 'visa'
export const SDK_ID_AMEX = 'amex'
export const SDK_ID_DISCOVER = 'discover'
export const SCOF_AUTH_NTS = 'SCOF_AUTH_NTS'
export const SCOF_AUTH_ICT = 'SCOF_AUTH_ICT'
export const SCOF_AUTH_ENC = 'SCOF_AUTH_ENC'
export const SDK_ID_MAESTRO = 'maestro'
export const SDK_IDS = {
  [SDK_ID_MASTERCARD]: SDK_ID_MASTERCARD,
  [SDK_ID_VISA]: SDK_ID_VISA,
  [SDK_ID_AMEX]: SDK_ID_AMEX,
  [SDK_ID_DISCOVER]: SDK_ID_DISCOVER
}

export const SDK_CAPITALIZE_NAMES = {
  [SDK_ID_MASTERCARD]: 'Mastercard',
  [SDK_ID_VISA]: 'Visa',
  [SDK_ID_AMEX]: 'Amex',
  [SDK_ID_DISCOVER]: 'Discover'
}

export const SRCI_ACTION_CODES = {
  newUser: 'NEW_USER'
}

export const SDK_ENUMS = {
  IdentityType: {
    emailAddress: 'EMAIL_ADDRESS',
    email: 'EMAIL',
    mobile: 'MOBILE',
    mobilePhoneNumber: 'MOBILE_PHONE_NUMBER'
  },
  IdentityProvider: {
    src: 'SRC'
  },
  SrciActionCodes: {
    newUser: 'NEW_USER',
    authFailed: 'AUTH_FAILED',
    authSkipped: 'AUTH_SKIPPED'
  }
}

export const DEFAULT_CHECKOUT_EXPERIENCE = 'DEFAULT'
export const INLINE_CHECKOUT_EXPERIENCE = 'INLINE'
export const INVISIBLE_CHECKOUT_EXPERIENCE = 'INVISIBLE'

export const CHECKOUT_EXPERIENCES = [
  DEFAULT_CHECKOUT_EXPERIENCE,
  INLINE_CHECKOUT_EXPERIENCE,
  INVISIBLE_CHECKOUT_EXPERIENCE
]

export const CHECKOUT_EXPERIENCE_LABELS = {
  'DEFAULT': 'Default Click to Pay Experience',
  'INLINE': 'Embedded Checkout - Inline Card Experience',
  'INVISIBLE': 'Invisible SRCI Experience'
}

export const PAY_BY_CARD = 'PAY_BY_CARD'
export const CLICK_TO_PAY = 'CLICK_TO_PAY'

export const PAYMENT_OPTIONS = [
  'PAY_BY_CARD',
  'CLICK_TO_PAY'
]

export const PAYMENT_OPTION_LABELS = {
  'PAY_BY_CARD': {
    label: 'Debit/Credit Card',
    image: 'card_logo.png'
  },
  'CLICK_TO_PAY': {
    label: 'Click To Pay',
    image: 'src_logo.jpg'
  }
}

export const AUTHENTICATION_REASONS = ['CONSUMER_IDENTITY_VALIDATION', 'ENROL_FINANCIAL_INSTRUMENT', 'TRANSACTION_AUTHENTICATION', 'AUTHENTICATOR_REGISTRATION']

export const SCOF_FLOW_OPTIONS = {
  '3DS': '3DS',
  'EXTERNAL_3DS': 'EXTERNAL 3DS',
  'TAV': 'TAV',
  'TXAV': 'TXAV',
  'MDES_IDV': 'MDES IDV'
}

export const SCOF_FLOW = {
  '3DS': '3DS',
  'TAV': 'TAV',
  'MDES_IDV': 'MDES_IDV',
  'TXAV': 'TXAV',
  'EXTERNAL_3DS': 'EXTERNAL_3DS'
}

export const THIRD_PARTY_FIDO_METHODS = {
  'FIDO_ATTESTATION': '3rd Party FIDO Attestation',
  'FIDO_ASSERTION': '3rd Party FIDO Assertion'
}

export const RETURNING_USER_CHECKOUT_APPROACH = [
  {
    key: '3DS PA',
    value: '3DS_PA'
  },
  {
    key: 'MANAGED AUTHENTICATION',
    value: 'MANAGED_AUTHENTICATION'
  },
  {
    key: 'MDES IDV',
    value: 'MDES_IDV'
  }

]

export const APP_EXTERNAL_LINKS = {
  'DEVELOPER_PORTAL': 'https://developer.mastercard.com/product/click-to-pay/',
  'SUPPORT_EMAIL': 'DST_Alberta_Avengers@mastercard.com',
  'TWITTER_LINK': 'https://twitter.com/mastercardnews',
  'API_LINK': 'https://developer.mastercard.com/apis',
  'CLICK_TO_PAY_LINK': 'https://www.mastercard.us/en-us/personal/ways-to-pay/click-to-pay.html'
}

export const SDK_METHODS = {
  INIT: 'init',
  IS_RECOGNIZED: 'isRecognized',
  IDENTITY_LOOKUP: 'identityLookup',
  INITIATE_IDENTITY_VALIDATION: 'initiateIdentityValidation',
  COMPLETE_IDENTITY_VALIDATION: 'completeIdentityValidation',
  GET_SRC_PROFILE: 'getSrcProfile',
  ENROLL_CARD: 'enrollCard',
  CHECKOUT: 'checkout',
  UNBIND_APP_INSTANCE: 'unbindAppInstance',
  AUTHENTICATE_CONSUMER: 'authenticate'
}

export const ENDPOINTS = {
  API: {
    GET_ENVIRONMENT: '/api/network/env',
    GET_ENVIRONMENT_BY_ID: '/api/network/endpoints?environmentId=',
    GET_SRC_CONFIG_BY_ENVIRONMENT: '/api/network/srci?environmentId=',
    PAYLOAD: '/api/checkout/payload',
    CONFIRMATION: '/api/checkout/confirmation',
    FEDERATED_TOKEN_MTT: '/masterpass/signJsonPayload',
    GET_SRC_KEYS: '/api/network/keys?environmentId=',
    GET_USER_ACCESS: '/api/user/access',
    CONSUMER_LOGIN: '/api/user/login/start',
    CONSUMER_REGISTRATION: '/api/user/register/start',
    FORGET_PWD: 'api/user/forget/start',
    RESET_PWD: 'api/user/reset/start',
    ENROLL: 'api/checkout/enroll',
    GET_SIGNATURE_HEADER: 'api/checkout/auth/signature-header',
    CHECKOUT_PAYLOAD: 'api/srci/checkout/payload/',
    CONFIRMATION_API: 'api/srci/checkout/confirmation/',
    BIND_MFA: 'api/src/auth/',
    SRC_SCOF_PAYLOAD: 'api/src/scof/payload',
    B2B_AUTH_LOOKUP: 'api/src/auth/lookup',
    TAV_GENERATE: '/api/src/auth/tav/generate',
    MDES_AUTHENTICATE: '/api/src/auth/authenticate',
    GET_CARD: '/api/src/scof/card',
    SCOF_RESULT: '/api/src/auth/results',
    THIRD_PARTY_PKI_DATA: 'api/src/das/pki/generate',
    FEDERATED_TOKEN_START: '/api/src/federated/auth/token'
  }
}

export const CHECKOUT_METHODS = {
  direct: {
    name: 'direct',
    description: 'Individual SDK'
  },
  aggregator: {
    name: 'aggregator',
    description: 'Aggregator SDK 13.28.0'
  }
}

export const SDK_PAYMENT_OPTIONS = {
  [SDK_ID_MASTERCARD]: ['dpaDynamicDataTtlMinutes', 'dynamicDataType'],
  [SDK_ID_VISA]: ['dpaPanRequested', 'dpaDynamicDataTtlMinutes', 'dynamicDataType'],
  [SDK_ID_AMEX]: ['dpaPanRequested', 'dynamicDataType'],
  [SDK_ID_DISCOVER]: ['dpaDynamicDataTtlMinutes']
}

export const SDK_TIMEOUT_MESSAGE = 'No Response from SDK after '
export const CARDS_ERROR = 'CARDS_ERROR'

export const CARD_TYPES = {
  'american-express': 'amex',
  visa: 'visa',
  mastercard: 'mastercard',
  discover: 'discover',
  maestro: 'maestro'
}

export const MAX_LENGTH = [
  { card: '', maxLength: 25 },
  { card: 'amex', maxLength: 25 },
  { card: 'visa', maxLength: 25 },
  { card: 'discover', maxLength: 25 },
  { card: 'mastercard', maxLength: 25 },
  { card: 'maestro', maxLength: 31 }
]

export const MASK_CARD_16_DIGIT_FORMAT = '#### - #### - #### - ####'
export const MASK_CARD_19_DIGIT_FORMAT = '#### - #### - #### - #### - ###'

export const JACKETS = 'Jackets'
export const T_SHIRTS = 'T-Shirts'
export const MERCHANDISE = 'Merchandise'

export const LOCALES = [
  { value: '-', label: '-- English --', separator: true },
  { value: 'en_AE', label: 'en_AE' },
  { value: 'en_AU', label: 'en_AU' },
  { value: 'en_CA', label: 'en_CA' },
  { value: 'en_GB', label: 'en_GB' },
  { value: 'en_HK', label: 'en_HK' },
  { value: 'en_IE', label: 'en_IE' },
  { value: 'en_IN', label: 'en_IN' },
  { value: 'en_KW', label: 'en_KW' },
  { value: 'en_NZ', label: 'en_NZ' },
  { value: 'en_QA', label: 'en_QA' },
  { value: 'en_SA', label: 'en_SA' },
  { value: 'en_SG', label: 'en_SG' },
  { value: 'en_TH', label: 'en_TH' },
  { value: 'en_US', label: 'en_US' },
  { value: 'en_ZA', label: 'en_ZA' },
  { value: '-', label: '-- Spanish --', separator: true },
  { value: 'es_AR', label: 'es_AR' },
  { value: 'es_CL', label: 'es_CL' },
  { value: 'es_CO', label: 'es_CO' },
  { value: 'es_MX', label: 'es_MX' },
  { value: 'es_PE', label: 'es_PE' },
  { value: '-', label: '-- Belarus --', separator: true },
  { value: 'ru_BY', label: 'ru_BY' },
  { value: '-', label: '-- French --', separator: true },
  { value: 'fr_CA', label: 'fr_CA' },
  { value: '-', label: '-- Malay --', separator: true },
  { value: 'ms_MY', label: 'ms_MY' },
  { value: '-', label: '-- Portuguese --', separator: true },
  { value: 'pt_BR', label: 'pt_BR' },
  { value: '-', label: '-- Ukraine --', separator: true },
  { value: 'uk_UA', label: 'uk_UA' },
  { value: '-', label: '-- Other --', separator: true },
  { value: 'Other', label: 'Other' }
]

export const ACCOUNT_LABELS = [
  'Profile',
  'Payment method',
  'Sign Out'
]

export const BAI_FIELDS_CONFIGURATION = {
  'FULL': ['name', 'country', 'lineFields', 'city', 'state', 'zip'],
  'POSTAL_COUNTRY': ['name', 'country', 'zip'],
  'NONE': ['name']
}

export const BILLING_ADDRESS_PREFERENCES = {
  'FULL': 'Full',
  'POSTAL_COUNTRY': 'Partial (Postal Code)',
  'NONE': 'None'
}

export const BOOLEAN_OPTIONS = [
  {
    key: 'True', value: true
  },
  {
    key: 'False', value: false
  }
]

export const AUTH_FLOW_OPTIONS = [
  {
    key: 'AuthSDK methods flow', value: 'SDK_METHODS_FLOW'
  },
  {
    key: 'Callback URL flow', value: 'CALLBACK_URL_FLOW'
  }
]

export const SCOF_API_LEVEL_CONFIG_OPTIONS = [
  {
    key: 'Use Global configuration', value: 'GLOBAL'
  },
  {
    key: 'Use IOS configuration', value: 'IND'
  }
]

export const AUTH_PRESENTATION_OPTIONS = [
  {
    key: 'Popup UI', value: 'POPUP_BASED'
  },
  {
    key: 'Action Sheet', value: 'ACTION_SHEET'
  }
]

export const MDES_FLOW_OPTIONS = [
  {
    key: 'B2B_API_FLOW', value: 'B2B API Flow'
  },
  {
    key: 'HOSTED_UI_FLOW', value: 'Hosted UI Flow'
  }
]

export const PFL_EXECUTION_FLOW_OPTIONS = [
  {
    key: 'EMBEDDED', value: 'EMBEDDED'
  },
  {
    key: 'HOSTED', value: 'HOSTED'
  }
]

export const WINDOW_REF_TYPE = [
  {
    key: 'iFrame',
    value: 'iFrame'
  },
  {
    key: 'Popup',
    value: 'popup'
  },
  {
    key: 'Action Sheet',
    value: 'actionSheet'
  }
]

export const windowRefTypes = {
  IFRAME: 'iFrame',
  POPUP: 'popup',
  ACTION_SHEET: 'actionSheet'
}

export const AUTH_METHODS = {
  LOOKUP: 'authenticationMethodsLookup',
  AUTHENTICATE: 'authenticate',
  B2BAUTHLOOKUP: 'b2bAuthLookup',
  TAVGENERATE: 'generatetav',
  AUTHENTICATEFORTXAV: 'authenticateForTxav',
  B2B_INITIATE_AUTHENTICATE: 'b2bMDESInitiateAuthenticate',
  B2B_COMPLETE_AUTHENTICATE: 'b2bMDESCompleteAuthenticate',
  B2B_AUTHENTICATE_ASSERTION: 'b2bAuthenticateWithAssertion',
  B2B_NTS_AUTHENTICATE_REGISTER: 'b2bNTSAuthenticateRegister',
  B2B_NTS_TRANSTION_AUTHENTICATION: 'b2bNTSTransactionAuthentication',
  B2B_CHECKOUT_TRANSACTION_AUTHENTICATION: 'checkoutWithTransactionAuthentication',
  AUTHENTICATEFORPROPRIETARY: 'authenticateForProprietary'
}

export const MFA_METHODS = {
  BIND: 'bindMFA',
  UNBIND: 'unbindMFA',
  PAYLOAD: 'scofPayload',
  BINDNTS: 'bindNTS',
  B2B_RESULT: 'b2bResult',
  THIRD_PARTY_PKI_ATTESTATION: 'getThirdPartyPKIAttestationRequest',
  THIRD_PARTY_PKI_ASSERTION: 'getThirdPartyPKIAssertionRequest',
  BIND_THIRD_PARTY_PKI: 'thirdPartyPKIBindMFA'
}

export const FIDO_METHODS = {
  SAVE_CARD: 'saveCard'
}

export const MFA_API_METHODS = {
  BIND: 'bindmfa',
  UNBIND: 'unbindmfa'
}

export const AUTH_URI_DATA = {
  URI:
    localStorage.getItem('setEnv') === 'Production'
      ? 'https://src.mastercard.com/auth'
      : `https://${(
        localStorage.getItem('setEnv') || ''
      ).toLocaleLowerCase()}.src.mastercard.com/auth`
}

export const AUTH_DPA_DATA = {
  Stage: {
    acquirerId: '550e8400',
    acquirerBin: '44444',
    merchantCategoryCode: '0008',
    merchantCountryCode: 'US'
  },
  ITF: {
    acquirerId: '550e8400',
    acquirerBin: '44444',
    merchantCategoryCode: '0008',
    merchantCountryCode: 'US'
  },
  Sandbox: {
    acquirerId: 'SRC3DS',
    acquirerBin: '545301',
    merchantCategoryCode: '0001',
    merchantCountryCode: '840'
  },
  Sandbox_IND: {
    acquirerId: 'SRC3DS',
    acquirerBin: '545301',
    merchantCategoryCode: '0001',
    merchantCountryCode: '356'
  },

  Production: {
    acquirerId: '',
    acquirerBin: '',
    merchantCategoryCode: '',
    merchantCountryCode: ''
  }

}

export const AUTH_METHOD_TYPE = {
  'ONBEHALF_ISSUER_IDV': 'ONBEHALF_ISSUER_IDV'
}
